// src/data/exercises/L2_07.js

const accountOptions = [
  '当座預金', '借入金', '支払利息', '現金', '未払利息'];

export const L2_07 = {
  title: '簿記　3級（第218-7回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
        { type: 'ruby', text: '取引銀行', ruby: 'とりひきぎんこう' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '借入金', ruby: 'かりいれきん' },
        { type: 'text', value: '￥3,000,000を、その' },
        { type: 'ruby', text: '利息', ruby: 'りそく' },
        { type: 'text', value: '￥90,000とともに' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '返済', ruby: 'へんさい' },
        { type: 'text', value: 'した。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '借入金', debitAmount: 3000000, creditAccount: '有価証券', creditAmount: 3090000 },
        { debitAccount: '支払利息', debitAmount: 90000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '現金で返済した。 \n' },
          { type: 'text', value: '①現金で返済なので、現金が減少（マイナス）します。 \n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '借入金￥3,000,000・・・返済した \n' },
          { type: 'text', value: '②借入金の返済なので、借入金が減少（マイナス）します。\n' },
          { type: 'styled', value: '借入金の減少（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: 'その利息 \n' },
          { type: 'text', value: '③その利息とは、借入金の利息です。 \n' },
          { type: 'text', value: '借入金の利息は支払利息になります。支払利息が発生します。 \n' },
          { type: 'styled', value: '支払利息の発生は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
                ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`現金で返済した。
①現金で返済なので、現金が減少（マイナス）します。

借入金￥3,000,000・・・返済した
②借入金の返済なので、借入金が減少（マイナス）します。

その利息
③その利息とは、借入金の利息です。
借入金の利息は支払利息になります。支払利息が発生します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '現金で返済した。 \n' },
          { type: 'text', value: '①現金で返済なので、現金が減少（マイナス）します。 \n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '借入金￥3,000,000・・・返済した \n' },
          { type: 'text', value: '②借入金の返済なので、借入金が減少（マイナス）します。\n' },
          { type: 'styled', value: '借入金の減少（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: 'その利息 \n' },
          { type: 'text', value: '③その利息とは、借入金の利息です。 \n' },
          { type: 'text', value: '借入金の利息は支払利息になります。支払利息が発生します。 \n' },
          { type: 'styled', value: '支払利息の発生は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
                ]
          }
        ],
       
      },
    },
  ],
};